<template>
  <div data-qa="duplicate-campaign-dialog">
    <el-dialog
      width="632px"
      :visible="dialogVisible"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @click.native.stop
      data-qa="duplicate-campaign-dialog-window"
      :show-close="false"
    >
      <div slot="title" data-qa="duplicate-campaign-dialog-title-wrapper">
        <div class="el-dialog__title" data-qa="duplicate-campaign-dialog-title">
          {{ $t('Gamification_Update_Campaign_URL') }}
        </div>
        <div class="sub-title" data-qa="duplicate-campaign-dialog-subtitle">
          {{ $t('Gamification_Update_Campaign_Name_To_Change_The_Slug_URL') }}
        </div>
      </div>

      <rest-form
        v-if="model"
        ref="duplicate-campaign-form"
        :model="model"
        :save-endpoint="{}"
        :after-save="handleClose"
        :rules="rules"
        data-qa="duplicate-campaign-form"
      >
        <form-item
          prop="name"
          :label="$t('Gamification_Campaign_Name')"
          :placeholder="$t('Gamification_Copy_Campaign_Name')"
          data-qa="duplicate-campaign-form-item-name"
        >
          <el-input
            v-model="model.name"
            required
            data-qa="duplicate-campaign-input-name"
            :disabled="loading"
          />
        </form-item>
      </rest-form>

      <div
        slot="footer"
        class="dialog-footer"
        data-qa="duplicate-campaign-footer"
      >
        <el-button
          type="primary"
          plain
          @click="handleClose"
          data-qa="duplicate-campaign-btn-back"
          :disabled="loading"
        >
          {{ $t('Gamification_Go_Back') }}
        </el-button>

        <el-button
          type="primary"
          @click="cloneEndpoint"
          data-qa="duplicate-campaign-btn-continue"
          :disabled="loading"
        >
          {{ $t('Gamification_Update_Continue') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import FormItem from '@/common/components/form/FormItem'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'DuplicateCampaignDialog',
  components: { RestForm, FormItem },
  props: {
    model: {
      type: Object,
      required: true
    },
    dialogVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      initialStateModel: null
    }
  },

  computed: {
    rules() {
      return {
        name: {
          required: true,
          message: this.$t(
            'Gamification_GameBasicSetupForm_CampaignNameRequired'
          ),
          trigger: 'blur'
        }
      }
    }
  },

  methods: {
    handleClose() {
      this.loading = false
      this.$emit('close')
    },

    cloneEndpoint() {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `gamify/${this.$route.params.id}/campaign/${this.model.campaignId}/clone`,
          data: {
            name: this.model.name
          }
        })
      )
        .then(() => {
          this.$message({
            message: this.$t('Gamification_Copy_Campaign_Successfully'),
            type: 'success'
          })
          this.$emit('close', true)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}

/deep/ .el-dialog__body {
  padding-bottom: 10px;
}

.sub-title {
  color: #606266;
  font-size: 14px;
  padding-top: 5px;
}

.dialog-body {
  height: 400px;
  overflow: scroll;
  word-break: initial;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 20px;
}

.dialog-footer {
  display: flex;
  gap: 24px;
  justify-content: end;
}

>>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog {
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/DuplicateCampaignDialog.vue